module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl3-75.033f4b20.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl3-75.png
// module id = 3533
// module chunks = 11